<template>
  <v-container
    fluid
    tag="section"
  >
    <v-card
      class="mx-auto pa-5"
      outlined
    >
      <v-row style="margin-bottom: 10px">
        <span style="font-weight: 600; margin-right: 5px">TÊN ĐẠI LÝ: </span>
        <span>{{agency.name}}</span>
      </v-row>
      <v-row style="margin-bottom: 10px">
        <span style="font-weight: 600; margin-right: 5px">SỐ ĐIỆN THOẠI: </span>
        <span>{{agency.phone}}</span>
      </v-row>
      <v-row style="margin-bottom: 10px">
        <span style="font-weight: 600; margin-right: 5px">NHÂN VIÊN KINH DOANH: </span>
        <span v-for="(user, key) in agency.users" :key="key">
          {{user.fullname}}<span style="margin-right:5px" v-if="parseInt(key) !== agency.users.length-1">,</span>
        </span>
      </v-row>
      <v-row style="margin-bottom: 10px">
        <span style="font-weight: 600; margin-right: 5px">TỈNH/THÀNH: </span>
        <div>{{ _.get(agency, 'province.ten', '') }}</div>
      </v-row>
      <v-row style="margin-bottom: 10px">
        <span style="font-weight: 600; margin-right: 5px">QUẬN/HUYỆN: </span>
        <div>{{ _.get(agency, 'district.ten', '') }}</div>
      </v-row>
      <v-row style="margin-bottom: 10px">
        <span style="font-weight: 600; margin-right: 5px">PHƯỜNG/XÃ: </span>
        <div>{{ _.get(agency, 'ward.ten', '') }}</div>
      </v-row>
      <v-row style="margin-bottom: 10px">
        <span style="font-weight: 600; margin-right: 5px">ĐỊA CHỈ CHI TIẾT: </span>
        <span>{{agency.detailAddress}}</span>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
  import RepositoryFactory from '@/repositories/RepositoryFactory'
  import * as moment from "moment";

  const AgencyRepository = RepositoryFactory.get('agency')
  const AddressRepository = RepositoryFactory.get('address');

  export default {
    $_veeValidate: {
      validator: 'new',
    },
    name: 'EditAgencyForm',
    props: {
      headerColor: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        isNew: false,
        agency: {
          name: '',
          phone: '',
          tinhId: '',
          huyenId: '',
          xaId: '',
          detailAddress: '',
          userIds: []
        },
        serviceGroups: [],
        files: null,
        thumbnailId: null,
        alert: true,
        loading: false,
        sites: [],
        provinces: [],
        districts: [],
        wards: [],
        listUsers: []
      }
    },
    computed: {
      pageTitle () {
        return this.isNew ? 'Tạo đại lý' : 'Sửa đại lý'
      },
      hasImage () {
        return this.displayImages.length ? '1' : ''
      },
      currentDate () {
        return moment().format('YYYY-MM-DD')
      },
      afterDate () {
        return moment().subtract(1, "days").format('YYYY-MM-DD')
      }
    },
    mounted () {
      let id = 0
      if ('id' in this.$route.params) {
        id = parseInt(this.$route.params.id, 10)
      }
      this.isNew = !id
      this.getDetails()
    },
    created() {
      this.getListUserByPermission()
    },
    methods: {
      async getDetails () {
        let self = this
        let id = 0
        if ('id' in this.$route.params) {
          id = parseInt(this.$route.params.id, 10)
        }
        if(!self.isNew) {
          self.loading = self.$loading.show()
          const response = await AgencyRepository.detail(id)

          if (!response.success) {
            self.$swal({
              type: 'error',
              title: 'Lỗi !',
              text: _.get(response, 'message', '')
            },
            ).then(() => {
              this.goToList()
            })
          } else {
            self.agency = response.data
            self.agency.userIds = []
            Object.values(response.data.users).forEach(i => {
              self.agency.userIds.push(i.id)
            })
          }
          self.loading.hide()
        } else return;
      },
      goToList () {
        this.$router.push({
          name: 'AgencyList',
        })
      },
      async getListUserByPermission() {
        const getList = await AgencyRepository.getListUserByPermission({
          model:'agency-user', action:'read'
        })
        if (getList.data.success) {
          this.listUsers = _.get(getList, 'data.data', [])
        }
      }
    },
  }
</script>
<style lang="scss" scoped>
    .v-card--material {
      overflow: hidden;
    }
    .clear-both {
      clear:both;
    }
    .display-none {
      display: none;
    }
  .v-input--radio-group__input .v-input--selection-controls__ripple {
    left: -12px;
  }
</style>
